import ModelUtil from '@leverege/model-util';
const TYPE = 'molten.FilterSourceModel';

/**
 * This represents one source of a filter - a search bar, or a table for example.
 * The FilterSourcesModel will use these to create a single query, as well as to 
 * manage saving the filter states. Metadata is for use by the source.
 */
function create() {
  return {
    type: TYPE,
    active: true,
    // If false, this is ignored
    priority: 1,
    filter: null,
    // what is Imagine Filter 
    sort: null,
    metadata: null // whatever you want
  };
}
export default {
  TYPE,
  create,
  ...ModelUtil.createAllValue('active'),
  ...ModelUtil.createAllValue('priority'),
  ...ModelUtil.createAllValue('filter'),
  ...ModelUtil.createAllValue('sort'),
  ...ModelUtil.createAllValue('metadata')
};